module.exports = __webpack_public_path__ + "static/media/user.67114d06.png";